import { defineComponent, openBlock, createElementBlock, normalizeStyle, createElementVNode, createCommentVNode } from 'vue';
import _export_sfc from '../_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "FillMaximize2",
  props: {
    gradient: {
      type: Boolean
    },
    opacity: {
      type: [Number, String],
      default: "0.35"
    },
    startColor: {
      type: String,
      default: ""
    },
    iconId: [String, Number]
  }
});
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["id"];
const _hoisted_3 = /* @__PURE__ */ createElementVNode("stop", {
  "stop-color": "currentColor",
  offset: "100%"
}, null, -1);
const _hoisted_4 = ["fill"];
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", { d: "M21,3 C21.5522847,3 22,3.44771525 22,4 L22,11 L20,11 L20,5 L4,5 L4,19 L10,19 L10,21 L3,21 C2.44771525,21 2,20.5522847 2,20 L2,4 C2,3.44771525 2.44771525,3 3,3 L21,3 Z M11.5,7 L9.457,9.043 L11.707,11.293 L10.293,12.707 L8.043,10.457 L6,12.5 L6,7 L11.5,7 Z" }, null, -1);
const _hoisted_6 = /* @__PURE__ */ createElementVNode("path", {
  d: "M21,13 C21.5522847,13 22,13.4477153 22,14 L22,20 C22,20.5522847 21.5522847,21 21,21 L13,21 C12.4477153,21 12,20.5522847 12,20 L12,14 C12,13.4477153 12.4477153,13 13,13 L21,13 Z",
  style: { "opacity": "var(--fill-opacity)" }
}, null, -1);
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": "Maximize2",
    role: "presentation",
    class: "icon-fill",
    style: normalizeStyle(`--fill-opacity: ${_ctx.opacity};`),
    fill: "currentColor"
  }, [
    _ctx.gradient ? (openBlock(), createElementBlock("defs", _hoisted_1, [
      createElementVNode("linearGradient", {
        id: `${_ctx.iconId}`,
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "100%",
        gradientUnits: "userSpaceOnUse"
      }, [
        createElementVNode("stop", {
          style: normalizeStyle({
            stopColor: _ctx.startColor ? _ctx.startColor : "var(--icon-start-color)"
          }),
          offset: "0%"
        }, null, 4),
        _hoisted_3
      ], 8, _hoisted_2)
    ])) : createCommentVNode("v-if", true),
    createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: _ctx.gradient ? "url(#" + _ctx.iconId + ")" : "currentColor",
      "fill-rule": "evenodd"
    }, _hoisted_7, 8, _hoisted_4)
  ], 4);
}
var Maximize2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { Maximize2 as default };
